import { axiosClient } from "./client";
import { SAVE_BANK_DETAILS, GET_BANK_DETAILS } from "./client/endpoints";

const saveBankDetails = async (data: object): Promise<any> => {
  const response = await axiosClient.post<any>(SAVE_BANK_DETAILS, data);
  return response.data;
};
const getBankDetails = async (): Promise<any> => {
  try {
    const response = await axiosClient.get<any>(GET_BANK_DETAILS);
    return response.data;
  } catch (e) {
    return null;
  }
};

const BankDetailsService = {
  saveBankDetails,
  getBankDetails,
};

export default BankDetailsService;
